import React from 'react'
import styled from 'styled-components'
import SvgIcon from 'components/atoms/SvgIcon'
import { IAges, IPriceBreakdownData, ISelectedGuests } from 'utils/reservation'
import { PriceBreakdown } from './PriceBreakDown'
import * as constants from '../../../../../static/constants'

interface IStartTimeDetailProps {
  memberPost: any
  isPrivate: boolean
  ages: IAges
  guests: ISelectedGuests
  prices: {
    private: IPriceBreakdownData | null
    adult: IPriceBreakdownData | null
    child: IPriceBreakdownData | null
    infant: IPriceBreakdownData | null
  }
}

const StartTimeDetail: React.VFC<IStartTimeDetailProps> = ({
  memberPost,
  isPrivate,
  ages,
  guests,
  prices,
}) => (
  <StartTimeDetailWrapper className="StartTime_Detail">
    {memberPost.meeting_points[0] && (
      <div>
        <p className="StartTime_SubLabel">Meeting Point</p>
        <a
          className="StartTime_MeetingPoint"
          href={`https://www.google.com/maps?q=${memberPost.meeting_points[0].latitude},${memberPost.meeting_points[0].longitude}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <SvgIcon name="place_filled" className="icon" />
          {memberPost.meeting_points[0].name}
        </a>
      </div>
    )}
    <div>
      <p className="StartTime_SubLabel">Price Breakdown</p>
      {isPrivate ? (
        <PriceBreakdown label="Guests" priceData={prices.private} />
      ) : (
        <>
          {guests.adults > 0 && (
            <PriceBreakdown label="Adults" priceData={prices.adult} ages={ages} isGroup={true} />
          )}
          {guests.children > 0 && (
            <PriceBreakdown label="Children" priceData={prices.child} ages={ages} isGroup={true} />
          )}
          {guests.infants > 0 && (
            <PriceBreakdown label="Infants" priceData={prices.infant} ages={ages} isGroup={true} />
          )}
        </>
      )}
    </div>
  </StartTimeDetailWrapper>
)

const StartTimeDetailWrapper = styled.div`
  > div {
    padding: 1.6rem 0;
    border-bottom: 1px solid ${constants.COLORS.divider2};
    @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
      padding: 1.2rem 0;
    }
  }

  .StartTime_SubLabel {
    font-size: 1.4rem;
    font-weight: bold;
    color: ${constants.COLORS.subText};
    line-height: 2rem;
    @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
      font-size: 1.3rem;
    }
  }

  .StartTime_MeetingPoint {
    color: ${constants.COLORS.primary};
    text-decoration: underline;
    @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
      font-size: 1.4rem;
    }
  }

  .StartTime_MeetingPoint .icon {
    width: 20px;
    height: 20px;
    margin-right: 0.4rem;
  }
`

export default StartTimeDetail
